/**
 * Custom Main Cart Enhancements
 * - Auto-delete items when quantity goes to 0
 */

class CustomMainCartEnhancements {
  constructor() {
    this.init();
  }

  init() {
    // Listen for minus button clicks to handle auto-deletion
    document.addEventListener('click', (event) => {
      if (event.target.closest('.quantity__button[name="minus"]') && 
          event.target.closest('#cart')) {
        this.handleMinusClick(event);
      }
    });

    // Listen for direct input changes
    document.addEventListener('input', (event) => {
      if (event.target.matches('#cart input[type="number"]')) {
        this.handleQuantityInput(event);
      }
    });
  }

  handleQuantityInput(event) {
    const input = event.target;
    const quantity = Number.parseInt(input.value, 10);
    if (Number.isNaN(quantity)) {
      return;
    }

    const minAttribute = Number.parseInt(input.getAttribute('min'), 10);
    const minValue = Number.isNaN(minAttribute) ? 1 : minAttribute;
    const shouldRemove = minValue <= 0 ? quantity <= 0 : quantity < minValue;

    if (shouldRemove) {
      this.removeCartItem(input);
    }
  }

  handleMinusClick(event) {
    const button = event.target.closest('.quantity__button[name="minus"]');
    if (!button) return;

    const quantityInput = button.parentElement.querySelector('input[type="number"]');
    if (!quantityInput) return;

    const currentValue = Number.parseInt(quantityInput.value, 10);
    if (Number.isNaN(currentValue)) {
      return;
    }

    const minAttribute = Number.parseInt(quantityInput.getAttribute('min'), 10);
    const minValue = Number.isNaN(minAttribute) ? 1 : minAttribute;
    const shouldRemove = minValue <= 0 ? currentValue <= 0 : currentValue < minValue;

    if (shouldRemove) {
      event.preventDefault();
      event.stopPropagation();
      this.removeCartItem(quantityInput);
      return false;
    }
  }

  removeCartItem(input) {
    const index = input.dataset.index;
    
    // Try to use the existing cart functionality
    const cartForm = document.querySelector('#cart');
    const cartItems = document.querySelector('cart-items');
    
    if (cartItems && typeof cartItems.updateQuantity === 'function') {
      cartItems.updateQuantity(index, 0);
    } else if (cartForm) {
      // Fallback: set quantity to 0 and submit
      input.value = '0';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

// Initialize the enhancements when the DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CustomMainCartEnhancements();
  });
} else {
  new CustomMainCartEnhancements();
}
